import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachetomcatComponent } from './simple-icons-apachetomcat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachetomcatComponent ],
    exports:      [ SimpleIconsApachetomcatComponent ],
    bootstrap:    []
})
export class SimpleIconsApachetomcatModule {}
